import { render, staticRenderFns } from "./Jumbo.vue?vue&type=template&id=7e082340&scoped=true&"
import script from "./Jumbo.vue?vue&type=script&lang=js&"
export * from "./Jumbo.vue?vue&type=script&lang=js&"
import style0 from "./Jumbo.vue?vue&type=style&index=0&id=7e082340&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e082340",
  null
  
)

export default component.exports